import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-errors"
export default class extends Controller {
  connect() {
    this.element.style.scrollMarginTop = "2rem";
    this.element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
